import { render, staticRenderFns } from "./sectionDialog.vue?vue&type=template&id=43fe9f52&scoped=true&"
import script from "./sectionDialog.vue?vue&type=script&lang=js&"
export * from "./sectionDialog.vue?vue&type=script&lang=js&"
import style0 from "./sectionDialog.vue?vue&type=style&index=0&id=43fe9f52&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43fe9f52",
  null
  
)

export default component.exports